import { sortBy } from 'lodash';
import { Listing } from 'types';

export const orderListings = (listings: Listing[]) => sortBy(listings, ['position', 'id']);
